import React, { useRef, useState, useEffect } from "react";
import sliderImg1 from "../../img/slider1.jpg";
import sliderImg2 from "../../img/slider2.jpg";
import sliderImg3 from "../../img/slider3.jpg";
import { phoneWhatsapp } from "../../config/phone";

const slides = [
  {
    image: sliderImg1,
    title: "Entre em contato com nossa equipe de profissionais",
    description:
      "Nossa equipe está pronta para atender você com agilidade e cuidado. Oferecemos suporte em Home Care, Equipamentos Eespiratórios e Aparelhos Auditivos, com orientação especializada para garantir conforto, segurança e qualidade de vida. Fale conosco e tire suas dúvidas.",
    buttonText: "Tire suas dúvidas",
    action: "Olá, gostaria de falar com a equipe"
  },
  {
    image: sliderImg2,
    title: "Seja nosso parceiro",
    description:
      "Buscamos parceiros comprometidos com a qualidade, o cuidado e o bem-estar dos pacientes. Se você é profissional ou empresa da área da saúde e deseja crescer conosco, entre em contato e conheça nossas oportunidades de parceria.",
    buttonText: "Saiba mais",
    action: "Olá, gostaria de falar sobre parceria"
  },
  {
    image: sliderImg3,
    title: "Nossa equipe de especialistas está pronta para te ajudar",
    description:
      "Conte com profissionais qualificados para orientar você nas melhores soluções em Home Care, Equipamanetos Respiratórios e Aparelhos Auditivos, sempre com atendimento humanizado e foco no seu bem-estar.",
    buttonText: "Entre em contato",
    action: "Olá, gostaria de conhecer mais"
  },
];

const ContactCTA = () => {
  const sliderRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(0);

  const handleDotClick = (index) => {
    setCurrentSlide(index);
    sliderRef.current.scrollTo({
      left: sliderRef.current.clientWidth * index,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    let interval = null;
    const start = () => {
      interval = setInterval(() => {
        setCurrentSlide((prev) => {
          const next = (prev + 1) % slides.length;
          if (sliderRef.current) {
            sliderRef.current.scrollTo({
              left: sliderRef.current.clientWidth * next,
              behavior: "smooth",
            });
          }
          return next;
        });
      }, 5000);
    };

    start();

    const el = sliderRef.current;
    const onEnter = () => clearInterval(interval);
    const onLeave = () => start();

    if (el) {
      el.addEventListener("mouseenter", onEnter);
      el.addEventListener("mouseleave", onLeave);
    }

    return () => {
      clearInterval(interval);
      if (el) {
        el.removeEventListener("mouseenter", onEnter);
        el.removeEventListener("mouseleave", onLeave);
      }
    };
  }, []);

  return (
    <div className="pb-12 mr-4 sm:mr-8 md:mr-14 ms-4 sm:ms-8 md:ms-14">
      <div className="relative mx-2 sm:mx-6 p-3 bg-[#f3f6f8] rounded-2xl shadow-md border border-gray-200 overflow-hidden w-full max-w-full">
        {/* Slides container */}
        <div
          ref={sliderRef}
          className="flex overflow-x-hidden snap-x snap-mandatory transition-transform duration-700 ease-in-out rounded-lg w-full"
          style={{ height: "auto", minHeight: 420 }}
        >
          {slides.map((slide, index) => (
            <div key={index} className="flex-shrink-0 w-full snap-start">
              <section
                className="relative flex items-center justify-start h-full overflow-hidden rounded-lg w-full"
                style={{
                  backgroundImage: `url(${slide.image})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                }}
              >
                {/* BLUR OVERLAY À ESQUERDA */}
                <div className="absolute left-blur-overlay" />

                {/* Conteúdo (texto) */}
                <div className="relative z-20 p-6 sm:p-8 md:p-12 w-full md:w-3/5 text-[#0f1724] text-wrap bg-white/80 rounded m-2 md:bg-transparent ">
                  <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-bold mb-4 leading-snug">
                    {slide.title}
                  </h2>
                  <p className="mb-6 text-sm sm:text-base leading-relaxed text-gray-700">
                    {slide.description}
                  </p>

                  <a
                    className="bg-black text-white pl-5 pr-2 py-2.5 rounded-full shadow-lg hover:bg-gray-800 transition-colors duration-300
             flex items-center max-w-[240px] text-sm sm:text-base"
                    href={`https://wa.me/${phoneWhatsapp}?text=${encodeURIComponent(slide.action)}`}
                  >
                    <span>{slide.buttonText}</span>

                    <div className="ml-auto flex items-center justify-center w-8 h-8 rounded-full bg-white text-black">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-4 w-4 transform -rotate-45"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth={2}
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M14 5l7 7m0 0l-7 7m7-7H3"
                        />
                      </svg>
                    </div>
                  </a>

                </div>
              </section>
            </div>
          ))}
        </div>
      </div>

      {/* Indicadores */}
      <div className="flex flex-col sm:flex-row items-center justify-center mt-6 space-y-3 sm:space-y-0 sm:space-x-4">
        <div className="w-2/3 sm:w-1/3 h-4 border-4 border-white rounded-md bg-white/20 p-0.5 overflow-hidden h-6">
          <div
            className="h-full bg-cyan-900 rounded transition-all duration-300"
            style={{ width: `${((currentSlide + 1) / slides.length) * 100}%` }}
          />
        </div>

        <div className="flex justify-center items-center space-x-1">
          {slides.map((_, i) => (
            <div
              key={i}
              className="rounded-full flex border-[4px] border border-white"
            >
              <button
                onClick={() => handleDotClick(i)}
                className={`dot-indicator p-1 ${currentSlide === i ? "active-dot" : ""
                  }`}
                aria-label={`Ir para slide ${i + 1}`}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ContactCTA;
